const ACCOUNT_SESSION_API = '/sitecore/api/ssc/rw/isagenix/autoshipapi';

export async function setupManageAutoship(request) {
    let token = $('input[name="__RequestVerificationToken"]').val();
    let url = `${ACCOUNT_SESSION_API}/SetupManageAutoship`;
    return $.ajax({
        headers: {
            __RequestVerificationToken: token
        },
        type: 'POST',
        url: url,
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(request)
    });
}
